import { ReactNode, createContext, useContext, useState } from "react";

interface NavbarBackgroundContextType {
  navbarBackground: string;
  setNavbarBackground: (color: string) => void;
}

const NavbarBackgroundContext = createContext<NavbarBackgroundContextType | undefined>(undefined);

interface NavbarBackgroundProviderProps {
  children: ReactNode;
}

export function NavbarBackgroundProvider({ children }: NavbarBackgroundProviderProps) {
  const [navbarBackground, setNavbarBackground] = useState<string>("transparent");

  return <NavbarBackgroundContext.Provider value={{ navbarBackground, setNavbarBackground }}>{children}</NavbarBackgroundContext.Provider>;
}

export function useNavbarBackground() {
  const context = useContext(NavbarBackgroundContext);
  if (context === undefined) {
    throw new Error("useNavbarBackground must be used within a NavbarBackgroundProvider");
  }
  return context;
}
